import { SaSmsGuard } from '@components/sa-sms-messaging/sa-sms-guard';
import { SaSmsNav } from '@components/sa-sms-messaging/sa-sms-nav';
import { SmsMigrationsTable } from '@components/sa-sms-messaging/sms-migrations-table';
import { ISaSmsMigration } from '@interfaces/sa-sms';
import { useNavigation } from '@refinedev/core';
import { Alert, Button, Select, Space } from 'antd';
import { useSaSmsErrorText, useSaSmsGet } from 'hooks/use-sa-sms-api';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const PAGE_SIZE = 25;

/** Super-admin SMS console: existing-number migration requests (status, notes, attach by number SID). */
export const SaSmsNumberMigrations: React.FC = () => {
    const { t } = useTranslation(['sa-sms']);
    const { push } = useNavigation();
    const errorText = useSaSmsErrorText();
    const [status, setStatus] = useState<string | undefined>();
    const [page, setPage] = useState(1);
    const { data, isLoading, isError, error, refetch } = useSaSmsGet<{
        items: ISaSmsMigration[];
        total: number;
    }>('/migrations', { status, page });
    return (
        <SaSmsGuard>
            {(canEdit) => (
                <section className="sa-sms-page">
                    <SaSmsNav active="migrations" />
                    <Space style={{ marginBottom: 16 }}>
                        <Select
                            allowClear
                            style={{ width: 200 }}
                            placeholder={t('approvals.status')}
                            value={status}
                            onChange={(v) => {
                                setStatus(v);
                                setPage(1);
                            }}
                            options={[
                                'submitted',
                                'in_progress',
                                'awaiting_customer',
                                'completed',
                                'rejected',
                                'cancelled',
                            ].map((v) => ({
                                value: v,
                                label: t(`migrations.status.${v}`),
                            }))}
                        />
                    </Space>
                    {isError && (
                        <Alert
                            type="error"
                            showIcon
                            message={errorText(error)}
                            style={{ marginBottom: 16 }}
                        />
                    )}
                    <SmsMigrationsTable
                        rows={data?.items ?? []}
                        loading={isLoading}
                        canEdit={canEdit}
                        onOpenTenant={(id) => push(`/sms-messaging/tenants/${id}`)}
                        onDone={() => refetch()}
                    />
                    <Space style={{ marginTop: 16 }}>
                        <Button disabled={page <= 1} onClick={() => setPage(page - 1)}>
                            {t('actions.previous')}
                        </Button>
                        <span>{t('list.page', { page })}</span>
                        <Button
                            disabled={page * PAGE_SIZE >= (data?.total ?? 0)}
                            onClick={() => setPage(page + 1)}
                        >
                            {t('actions.next')}
                        </Button>
                    </Space>
                </section>
            )}
        </SaSmsGuard>
    );
};
